import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';

import { getContentBlockItemsByName, getContentBlockMixedItem, getContentBlockItemValue } from '../../../CmsActions.js';
import HtmlComponent from '../../../../../components/Text/HtmlComponent.js';

function PanelExitIntent({ panel }) {
    const promos = getContentBlockItemsByName(panel.blocks, 'promo');
    const promo1 = promos[0] || null;
    const promo2 = promos[1] || null;
    const promo1Html = getContentBlockMixedItem(promo1, 'content')?.text || '';
    const promo2Html = getContentBlockMixedItem(promo2, 'content')?.text || '';
    const extraHtml = getContentBlockItemValue(panel.blocks, 'extra');

    return (
        <div className="bg-info p-3 pb-2">
            <Row className="g-2 mb-3">
                <Col xs="12" md="5">
                    <div className="bg-white border rounded p-3 h-100 text-center shadow d-flex flex-column">
                        <div className="flex-grow-1"><HtmlComponent text={promo1Html} /></div>
                        <Button variant="danger" size="sm" className="mt-2 w-100" disabled>
                            Je profite de l&apos;offre
                        </Button>
                    </div>
                </Col>
                <Col xs="12" md="2" className="d-flex align-items-center justify-content-center py-2 py-md-0">
                    <span className="text-secondary fw-bold">OU</span>
                </Col>
                <Col xs="12" md="5">
                    <div className="bg-white border rounded p-3 h-100 text-center shadow d-flex flex-column">
                        <div className="flex-grow-1"><HtmlComponent text={promo2Html} /></div>
                        <Button variant="danger" size="sm" className="mt-2 w-100" disabled>
                            Je profite de l&apos;offre
                        </Button>
                    </div>
                </Col>
            </Row>
            <HtmlComponent text={extraHtml} />
        </div>
    );
}

PanelExitIntent.propTypes = {
    panel: PropTypes.object.isRequired,
};

export default PanelExitIntent;
